import { render, staticRenderFns } from "./member-workOrder-logs.vue?vue&type=template&id=6b964fd8&scoped=true&"
import script from "./member-workOrder-logs.vue?vue&type=script&lang=js&"
export * from "./member-workOrder-logs.vue?vue&type=script&lang=js&"
import style0 from "./member-workOrder-logs.vue?vue&type=style&index=0&id=6b964fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b964fd8",
  null
  
)

component.options.__file = "member-workOrder-logs.vue"
export default component.exports